import wx from "weixin-js-sdk"
import qs from "qs"
import request from "../http/index"

export default async function (options) {
    let query = qs.parse(window.location.search.split('?')[1])
    delete query.code
    //默认分享路径
    let defaultHref = window.location.origin + window.location.pathname + '?' + qs.stringify(query)
    console.log(defaultHref)
    let data = {}
    let res = await request.get("get_jssdk", {
        params: {
            url: window.location.href
        }
    })
    console.log(res)
    //看具体数据
    data.jssdk = res.data.jssdk

    const shareDataObj = {
        title: options?.title,
        desc: "",
        link: defaultHref,
        imgUrl: "https://keyang2.tuzuu.com/uuo/ylh/752ed46dee9a454a0c25dfc59f2776.jpg"
    }

    wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.jssdk.appId, // 必填，公众号的唯一标识
        timestamp: data.jssdk.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.jssdk.nonceStr, // 必填，生成签名的随机串
        signature: data.jssdk.signature,// 必填，签名
        jsApiList: data.jssdk.jsApiList, // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp']
    })
    wx.ready(function () {
        if (wx.updateAppMessageShareData) {
            wx.updateAppMessageShareData({
                title: shareDataObj.title,
                desc: shareDataObj.desc,
                link: shareDataObj.link,
                imgUrl: shareDataObj.imgUrl,
                success: function () {
                    console.log('分享朋友成功')
                },
                fail: function (error) {
                    console.log(error)
                    console.log('分享朋友失败')
                }
            })
        }
        if (wx.updateTimelineShareData) {
            wx.updateTimelineShareData({
                title: shareDataObj.title,
                link: shareDataObj.link,
                imgUrl: shareDataObj.imgUrl,
                success: function () {
                    console.log('分享朋友圈')
                },
                fail: function () {
                    console.log('分享朋友圈失败')
                }
            })
        }
        if (wx.onMenuShareAppMessage) {
            wx.onMenuShareAppMessage({
                title: shareDataObj.title,
                desc: shareDataObj.desc,
                link: shareDataObj.link,
                imgUrl: shareDataObj.imgUrl,
                success: function () {
                    console.log('旧版本分享朋友成功')
                },
                fail: function () {
                    // console.log('rnmsds=')
                    console.log('旧版本分享朋友失败')
                }
            })
        }
        if (wx.onMenuShareTimeline) {
            wx.onMenuShareTimeline({
                title: shareDataObj.title,
                link: shareDataObj.link,
                imgUrl: shareDataObj.imgUrl,
                success: function () {
                    console.log('旧版本分享朋友圈')
                },
                fail: function () {
                    console.log('旧版本分享朋友圈失败')
                }
            })
        }
    })
}
